import type { TransactionCurrency } from '@contracts/payment/Currency';
import { TransactionCurrencyValues } from '@contracts/payment/Currency';
import * as yup from 'yup';

export const CurrenciesSchema = yup
  .array(
    yup
      .string()
      .oneOf(TransactionCurrencyValues as string[])
      .transform((value) => value as TransactionCurrency)
      .defined(),
  )
  .defined();
